import './Database.scss';

import React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteNode } from 'react-router5';

import Frame from '../Frame/Frame';
import Popup from "../../Components/Popup/Popup"
import { STORE_CONFIG } from '../../Store/ConfigStore';
import { ROUTE_DATABASE } from '../../routes';
import { STORE_DATABASE } from '../../Store/DatabaseStore';
import { formatDate } from '../../utility';

import Select from 'react-select'
import { SelectStyle, DropdownIndicator } from '../App/select_style'

const options = [
  { value: 'items', label: 'Faj / fajta' },
  { value: 'suppliers', label: 'Beszállító' }
]

@inject(stores => ({
  store: stores.store.get(STORE_DATABASE),
  configStore: stores.store.get(STORE_CONFIG),
  socket: stores.socket,
  router: stores.router
}))
@observer
class Database extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: 'none',
      popupText: '',
      popupButtons: null,
      selectedOption: options[0],
      items: [],
      selectedItem: null,
      suppliers: [],
      suppliername: '',
      supplieraddress: '',
      itemname: '',
      subitemname: ''
    }

    this.getItems()
  }

  getItems() {
    const obj = this
    this.props.socket.emitWithToken('GetItems', {}, function (err, data) {
      if (err) {
        console.error(err)
        return
      }
      console.log(data)
      obj.setState(prevState => {

        let selectedItem = prevState.selectedItem

        if (prevState.selectedItem) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].Id == selectedItem.Id) {
              selectedItem = data[i]
              break
            }
          }
        }

        return {
          items: data,
          selectedItem: selectedItem
        }
      })
    })
  }

  getSuppliers() {
    const obj = this
    this.props.socket.emitWithToken('GetSuppliers', {}, function (err, data) {
      if (err) {
        console.error(err)
        return
      }
      obj.setState({
        suppliers: data
      })
    })
  }

  refresh() {

    switch (this.state.selectedOption.value) {
      case 'items':
        this.getItems()
        break

      case 'suppliers':
        this.getSuppliers()
        break
    }
  }

  handleItemClick(e) {
    console.log(e)
  }

  handleOptionChanged(option) {

    switch (option.value) {
      case 'items':
        this.getItems()
        break

      case 'suppliers':
        this.getSuppliers()
        break
    }

    this.setState((prevState) => {
      return {
        selectedOption: option,
        selectedItem: null,
        itemname: '',
        subitemname: '',
        suppliername: '',
        supplieraddress: ''
      }
    })
  }

  handleSupplierNameChange(text) {
    this.setState({
      suppliername: text
    })
  }

  handleSupplierAddressChange(text) {
    this.setState({
      supplieraddress: text
    })
  }

  handleItemNameChange(text) {
    this.setState({
      itemname: text
    })
  }

  handleSubitemNameChange(text) {
    this.setState({
      subitemname: text
    })
  }

  handleAddClick(type) {

    let data = null

    switch (type) {

      case 'item':
        if (this.state.itemname.length > 0) {
          data = {
            Type: 'item',
            Name: this.state.itemname
          }
        }
        break

      case 'subitem':
        if (this.state.selectedItem && this.state.subitemname.length > 0) {
          data = {
            Type: 'subitem',
            ItemId: this.state.selectedItem.Id,
            Name: this.state.subitemname
          }
        }
        break

      case 'supplier':
        if (this.state.suppliername.length > 0 && this.state.supplieraddress.length > 0) {
          data = {
            Type: 'supplier',
            Name: this.state.suppliername,
            Address: this.state.supplieraddress
          }
        }
        break
    }

    if (!data) {
      this.setState({
        popup: true,
        popupText: 'Hiányos adatok!'
      })
      return
    }

    const obj = this
    this.props.socket.emitWithToken('InsertData', data, function (err, data) {
      if (err) {
        obj.setState({
          popup: true,
          popupText: err
        })
        return
      }
      obj.refresh()
      obj.setState({
        itemname: '',
        subitemname: '',
        suppliername: '',
        supplieraddress: ''
      })
    })
  }

  handleDeleteClick(type, id) {

    const data = {
      Type: type,
      Id: id
    }

    const buttons = <div className='popup_buttons_wrapper'>
      <span className='popup_button' onClick={e => { this.setState({ popup: 'none' }), this.deleteData(data) }}>Igen</span>
      <span className='popup_button' onClick={e => this.setState({ popup: 'none' })}>Mégse</span>
    </div>

    this.setState({
      popup: 'delete',
      popupText: 'Biztosan törli?',
      popupButtons: buttons
    })
  }

  deleteData(data) {
    const obj = this
    this.props.socket.emitWithToken('DeleteData', data, function (err, data) {
      if (err) {
        obj.setState({
          popup: true,
          popupText: err
        })
        return
      }
      obj.refresh()
      obj.setState({
        itemname: '',
        subitemname: '',
        suppliername: '',
        supplieraddress: ''
      })
    })
  }

  render() {

    let table = []

    switch (this.state.selectedOption.value) {

      case 'items':
        table = this.state.items.map(item => {
          const className = 'database_listelement' + (this.state.selectedItem == item ? ' selected' : '')
          const deleteClassName = 'delete_data' + (this.state.selectedItem == item ? ' inverse' : '')
          return <tr class={className} onClick={() => this.setState(prevState => { return { selectedItem: prevState.selectedItem == item ? null : item } })}>
            <td className='database_cell'>
              {item.Name}
              <div className={deleteClassName} onClick={e => this.handleDeleteClick('item', item.Id)}></div>
            </td>
          </tr>
        })
        break

      case 'suppliers':
        table = this.state.suppliers.map(supplier => {
          return <tr class='database_listelement'>
            <td>{supplier.Name}</td>
            <td>{supplier.Address}</td>
            <div className='delete_data' onClick={e => this.handleDeleteClick('supplier', supplier.Id)}></div>
          </tr>
        })
        break
    }

    return <Frame>
      <div className="database basic-content">
        <div className="database__top">
          Válasszon adattípust
          <Select
            className='react-select fixwidth'
            options={options}
            value={this.state.selectedOption}
            onChange={option => { this.handleOptionChanged(option) }}
            isClearable={false}
            isSearchable={false}
            styles={SelectStyle}
            components={{ DropdownIndicator }}
          />

        </div>
        <div className="database__content">

          <div className='database_list_tab'>
            <div className='database_list_header'>{this.state.selectedOption.value == 'items' ? 'FAJ' : 'BESZÁLLÍTÓ'}</div>

            {this.state.selectedOption.value == 'items' ?
              <div className='input_row'>
                <div className='search-wrapper'>
                  <input className='search-input' placeholder='Új faj neve' value={this.state.itemname} onChange={e => this.handleItemNameChange(e.target.value)} />
                </div>
                <div className='input_add' onClick={() => this.handleAddClick('item')}>+</div>
              </div>
              :
              <div className='input_row'>
                <div className='search-wrapper'>
                  <input className='search-input' placeholder='Új beszállító neve' value={this.state.suppliername} onChange={e => this.handleSupplierNameChange(e.target.value)} />
                </div>
                <div className='search-wrapper'>
                  <input className='search-input' placeholder='Új beszállító címe' value={this.state.supplieraddress} onChange={e => this.handleSupplierAddressChange(e.target.value)} />
                </div>
                <div className='input_add' onClick={() => this.handleAddClick('supplier')}>+</div>
              </div>
            }
            <div className='database_list scrollable'>
              <table>{table}</table>
            </div>
          </div>

          {this.state.selectedOption.value == 'items' ?
            <div className='database_list_tab'>
              <div className='database_list_header'>FAJTA</div>

              {this.state.selectedItem ?
                <div className='input_row'>
                  <div className='search-wrapper'>
                    <input className='search-input' placeholder='Új fajta neve' value={this.state.subitemname} onChange={e => this.handleSubitemNameChange(e.target.value)} />
                  </div>
                  <div className='input_add' onClick={() => this.handleAddClick('subitem')}>+</div>
                </div>
                :
                <div className='input_row inactive'>
                  Válasszon fajt!
              </div>}

              <div className='database_list scrollable'>
                <table>
                  {this.state.selectedItem ?
                    this.state.selectedItem.SubItems.map(subitem => {
                      return <tr class='database_listelement'>
                        <td class='database_cell'>
                          {subitem.Name}
                          <div className='delete_data' onClick={e => this.handleDeleteClick('subitem', subitem.Id)}></div>
                        </td>
                      </tr>
                    })
                    : null}
                </table>
              </div>
            </div>
            : null}

        </div>
      </div>
      {this.state.popup == 'none' ? null : <Popup key='popup' text={this.state.popupText} buttons={this.state.popup == 'delete' ? this.state.popupButtons : null} showCloseButton={this.state.popup == 'delete' ? false : true} onClickClose={() => this.setState({ popup: 'none' })} />}
    </Frame>
  }
}

export default (props) => <RouteNode nodeName={ROUTE_DATABASE}>
  {routeProps => <Database {...routeProps} {...props} />}
</RouteNode>